var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "watchDiv",
    staticClass: "top-gift-page"
  }, [_vm.list.length === 0 ? _c('div', {
    staticClass: "nodata"
  }) : _c('div', {
    staticClass: "top-gift-list"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: "item".concat(index),
      staticClass: "item"
    }, [_c('div', {
      staticClass: "order",
      class: {
        'no1': index === 0,
        'no2': index === 1,
        'no3': index === 2
      }
    }, [_vm._v("\n                " + _vm._s(index !== 0 && index !== 1 && index !== 2 ? index + 1 : '') + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "head",
      style: {
        backgroundImage: "url(".concat(_vm.turnHttps(item.face || _vm.defaultUserPortrait(item)), ")")
      },
      on: {
        "click": function click($event) {
          return _vm.opencard(item, $event);
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.uname || item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "icon",
      style: {
        'background-image': _vm.getLevelImage(item.level)
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.level))])])]), _vm._v(" "), _c('div', {
      staticClass: "contribute"
    }, [_vm._v("\n                    Contribute\n                    "), _c('div', {
      staticClass: "daimond"
    }, [_vm._v(_vm._s(_vm._f("format")(item.cnt || item.contribution || 0)))])])])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };